import React from 'react';
import { useSelectPersonInWorkEventFieldQuery } from 'generated/graphql';

export type IData = {
  id: string;
  name: string;
  displayName: string;
};

export function useQuery(projectId: string) {
  const tuple = useSelectPersonInWorkEventFieldQuery({
    variables: {
      options: {
        filter: {
          projectId,
          roleName: 'contractor'
        }
      }
    },
    skip: projectId === ''
  });

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.persons?.map((node) => ({
        id: node?.id ?? '',
        name: node?.id ?? '',
        displayName: node?.fullName ?? ''
      }
      )) ?? [];

      return {
        ...tuple,
        data
      };
    }
    , [tuple]
  );
}
